<div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-5 py-7 sm:px-8 sm:pt-12">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      What do you <span class="text-primary">need?</span>
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Content for your own channels and ads, or creators posting to their audiences.</p>
  </div>

  <div class="flex flex-col gap-3" role="group" aria-label="What do you need?">
    <button type="button" class="flex w-full items-start gap-4 rounded-xl p-4 text-left" [class]="optionClass(brief.format() === 'ugc')" [attr.aria-pressed]="brief.format() === 'ugc'" (click)="brief.selectFormat('ugc')">
      <span class="flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" class="size-6">
          <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
          <rect x="2" y="6" width="14" height="12" rx="2" />
        </svg>
      </span>
      <span class="min-w-0 flex-1">
        <span class="block text-xl font-bold">UGC content only</span>
        <span class="block text-base font-medium text-muted-foreground">Creators film content for you. You post it on your channels and use it in ads.</span>
        <span class="mt-2 block text-sm font-bold text-muted-foreground">Videos and photos · Usage rights included</span>
      </span>
    </button>
    <button type="button" class="flex w-full items-start gap-4 rounded-xl p-4 text-left" [class]="optionClass(brief.format() === 'influencer')" [attr.aria-pressed]="brief.format() === 'influencer'" (click)="brief.selectFormat('influencer')">
      <span class="flex size-12 shrink-0 items-center justify-center rounded-lg bg-brand-studio text-white" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" class="size-6">
          <path d="m3 11 18-5v12L3 13v-2z" /><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
        </svg>
      </span>
      <span class="min-w-0 flex-1">
        <span class="block text-xl font-bold">Influencer posts</span>
        <span class="block text-base font-medium text-muted-foreground">Creators post about you on their own social channels to reach their audiences.</span>
        <span class="mt-2 block text-sm font-bold text-muted-foreground">Reach new audiences · Tracked performance</span>
      </span>
    </button>
  </div>

  @if (brief.error()) {
    <p class="m-0 text-base font-semibold text-red-600" role="alert">{{ brief.error() }}</p>
  }

</div>
<div class="shrink-0 border-t border-border bg-background px-5 py-3 sm:px-8">
  <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full" (click)="brief.continueFromFormat()">{{ brief.continueLabel() }}</button>
</div>
